import request from '@/utils/request'
import '@/utils/types.js'

export function passwordChange(data, token) {
  return request({
    url: `/api/account/password/change/`,
    method: 'post',
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data,
  })
}
